/**
 * 앱 라우터 싱글톤
 *
 * React 트리 바깥(예: React Query 의 onError 핸들러, axios 인터셉터)에서도
 * `useNavigate` 없이 라우터 기반 이동을 할 수 있게 한다.
 */
import type { NavigateOptions, To } from 'react-router-dom';

import { createAppRoutes } from './routes';

export const appRouter = createAppRoutes();

export const navigateTo = (to: To, options?: NavigateOptions) => appRouter.navigate(to, options);
